import angular from 'angular';
import htmlTemplate from './hvt-sale-summary.directive.html';
import _, { template } from 'underscore';

(function () {
    "use strict";

    angular.module("cardspotWeb.areas.hvtFulfillment")
        .directive("emlHvtSaleSummary", configDirective);

    function configDirective() {
        return {
            restrict: "E",
            scope: {
                cardsPreActivated: "=",
                saleCompleted: "=",
                isTrailingSymbol: "=",
                currencySeparators: "=",
                fractionSize: "=",
                currentLanguage: "=",
                customer: "=",
                payments: "="
            },
            controller: HvtSaleSummaryController,
            controllerAs: "model",
            template: htmlTemplate
        };
    }

    HvtSaleSummaryController.$inject = ["$scope", "cardFees", "preActivationService", "authService", "appConfig", "lookupValues",
        "activationService", "customerService", "CLAIMS", "DEFAULT_SALES_CHANNEL", "REGION_TYPES", "EVENT_NAMES", "navigate", 
        "$uibModal", "$rootScope", "notify", "hvtRequestService"];

    function HvtSaleSummaryController($scope, cardFees, preActivationService, authService, appConfig, lookupValues,
        activationService, customerService, CLAIMS, DEFAULT_SALES_CHANNEL, REGION_TYPES, EVENT_NAMES, navigate, 
        $uibModal, $rootScope, notify, hvtRequestService) {

        var model = this, defaultSalesChannel;
        model.canAddFee = authService.hasClaim(CLAIMS.ADD_FEE);
        model.canDeleteFee = authService.hasClaim(CLAIMS.DELETE_FEE);
        model.canModifyFee = authService.hasClaim(CLAIMS.MODIFY_ACTIVATION_FEE);
        model.canLockCard = authService.canLockCard();
        model.cardsPreActivated = undefined;
        model.havePayments = havePayments;
        model.paymentsTotal = 0;
        model.remainingBalance = 0;
        model.completeSale = completeSale;
        model.showCompleteSale = showCompleteSale;
        model.completeSaleInProgress = false;
        model.currentLanguage = $scope.currentLanguage;
        model.paymentToRemove = undefined;
        model.cancelSale = cancelSale;
        model.meetsSaleRequirements = meetsSaleRequirements;
        model.completeSaleButtonEnabled = completeSaleButtonEnabled;
        model.hvtCards = [];

        var TAB_NAMES = {
            PAYMENT: "payment",
            FEES: "fees",
            CUSTOMER: "customer",
            NOTES: "notes"
        };
        $scope.TAB_NAMES = TAB_NAMES;
        var activeTab = TAB_NAMES.PAYMENT;

        $scope.tabClass = function (tabName) {
            var cssClass = "";
            if (tabName === activeTab) {
                cssClass = "active";
            }

            return cssClass;
        };

        $scope.tabVisible = function (tabName) {
            return tabName === activeTab;
        };

        $scope.changeActiveTab = function (tab) {
            activeTab = tab;

            if (tab === TAB_NAMES.FEES) {
                $scope.$broadcast($scope.HVT_FEES_TAB_SHOWN_EVENT, {});
            }

            if (tab === TAB_NAMES.CUSTOMER) {
                $scope.$broadcast($scope.CUSTOMER_TAB_SHOWN_EVENT, {});
            }
        };

        function meetsSaleRequirements() {
            var saleRequirementsMet = false;

            if (model.customer) {
                saleRequirementsMet = true;
            }

            return saleRequirementsMet;
        }

        $scope.$on(EVENT_NAMES.SHOWING_HVT_SALE_SUMMARY, function () {
            initModel();
        })

        $scope.HVT_FEES_TAB_SHOWN_EVENT = "hvt-fees-tab-shown";
        $scope.HVT_FEES_CHANGED_EVENT = "hvt-fees-changed";
        $scope.HVT_PAYMENTS_CHANGED_EVENT = "hvt-payments-changed";
        $scope.CUSTOMER_TYPE_CHANGED_EVENT = "customer-type-changed";
        $scope.CUSTOMER_TAB_SHOWN_EVENT = "customer-tab-shown";

        $scope.$on(EVENT_NAMES.SHOWING_HVT_SALE_SUMMARY, function () {
            updateModel();
            refreshFeeTab();
        });
        $scope.$on($scope.HVT_FEES_CHANGED_EVENT, function () {
            updateModel();
        });
        $scope.$on($scope.HVT_PAYMENTS_CHANGED_EVENT, function () {
            updatePaymentsTotal();
        });

        function showCompleteSale() {
            return havePayments() && model.remainingBalance <= 0;
        }

        lookupValues.getSalesChannels().then(function (data) {
            model.salesChannels = data;

            defaultSalesChannel = _.find(model.salesChannels, function (salesChannel) {
                return salesChannel.name === DEFAULT_SALES_CHANNEL;
            }) || model.salesChannels[0];
            initModel();
        });

        function initModel() {
            model.payments = $scope.payments?.length > 0 ? $scope.payments : [];
            model.hvtCards = [];
            model.note = "";
            if (!model.customer) {
                model.customer = $scope.customer;
            }
            model.salesChannel = defaultSalesChannel;
            model.lockTransactionOnActivation = false;
            model.completeSaleInProgress = false;
        }

        $scope.$on('hvtCardsActivated', function (event, success) {
            angular.forEach(model.flattenedCardsPreActivated, function (cardPreactivated) {
                model.hvtCards.push({
                    hvtRequestCardAmountId: cardPreactivated.cardAmountId,
                    cardId: cardPreactivated.cardId
                })
            })
            //insert hvt cards
            notify.forHttp(hvtRequestService.insertHvtRequestCards(model.hvtCards), 
                { startTranslationId: 'HVT.HVT_FULFILLMENT.PROGRESS_MESSAGES.INSERT_HVT_CARDS' })
            .then(function (response) {
                if (response.succeeded) {
                    model.customer = undefined;
                    initModel();
                    customerService.reset();
                    preActivationService.reset();
                    $scope.saleCompleted();
                } else {
                    notify.showError("HVT.HVT_FULFILLMENT.ERROR_MESSAGES.INSERT_HVT_CARDS_FAILED");
                }
            })
        })

        function activateCards() {
            activationService.setActivationCardCustomerEmail(model.customer.email);
            
            var customer;
            if ((model.customer.firstName && model.customer.lastName) || model.customer.companyName) {
                customer = angular.copy(model.customer);
                customer.country = model.customer.country ? model.customer.country : null;
                if (model.customer.selectedRegion) {
                    if (model.customer.selectedRegion.length > 2)
                        customer.province = model.customer.selectedRegion
                    else
                        customer.state = model.customer.selectedRegion;
                }
            } else {
                customer = null;
            }

            activationService.activate(model.payments, model.salesChannel.name, model.note, customer, model.lockTransactionOnActivation === true, true)
                .then(function (response) {
                    handleActivationResponse(response);
                });
        }

        function handleActivationResponse(response) {
            if (response.confirmation.succeeded) {
                $scope.$broadcast('hvtCardsActivated');
            } else {
                notify.showError("HVT.HVT_FULFILLMENT.ERROR_MESSAGES.CARD_ACTIVATIONS_FAILED")
            }
        }

        function updatePaymentsTotal() {
            model.paymentsTotal = _.reduce(model.payments, function (memo, payment) {
                return memo + payment.amount;
            }, 0);

            model.remainingBalance = Number(model.totalAmount.toFixed(2)) - Number(model.paymentsTotal.toFixed(2));
        }

        function havePayments() {
            return angular.isArray(model.payments) && model.payments.length > 0;
        }

        function updateModel() {
            var cards = preActivationService.getCardsPreActivated();
            var perCardFees = cardFees.getPerCardFees();

            angular.forEach(cards, function (card) {
                card.perCardFee = _.find(perCardFees, function (fee) {
                    return fee.cardType === card.currentCardType
                })
            });

            model.cardsPreActivated = cards;

            var flattenedCardsPreActivated = [];
            angular.forEach(model.cardsPreActivated, function (cardPreActivated) {
                if (cardPreActivated.cards) {
                    angular.forEach(cardPreActivated.cards, function (card) {
                        card.amount = cardPreActivated.amount;
                        card.perCardFee = cardPreActivated.perCardFee;
                        flattenedCardsPreActivated.push(card);
                    })
                } else {
                    flattenedCardsPreActivated.push(cardPreActivated);
                }
            });

            model.flattenedCardsPreActivated = flattenedCardsPreActivated;

            model.hasCards = preActivationService.hasCards();
            model.transactionFees = appConfig.selectedMerchantGroup().supportsCustomerAtCardLevel ? null : cardFees.getTransactionFees();
            model.haveTransactionFees = angular.isArray(model.transactionFees) && model.transactionFees.length > 0;
            model.currencySymbol = getCurrencySymbol();

            model.totalCardCount = _.reduce(cards, function (memo, card) {
                var cardCount = angular.isArray(card.cards) ? card.cards.length : 1;
                return memo + cardCount;
            }, 0);

            model.totalCardAmount = _.reduce(cards, function (memo, card) {
                var qty = angular.isArray(card.cards) ? card.cards.length : 1;
                return parseFloat((memo + (card.amount * qty)).toFixed(2));
            }, 0);

            model.totalFeeAmount = _.reduce(cards, function (memo, card) {
                var qty = angular.isArray(card.cards) ? card.cards.length : 1;
                return memo + (card.perCardFee ? card.perCardFee.perCardFee * qty : 0);
            }, 0) + _.reduce(model.transactionFees, function (memo, fee) {
                return memo + fee.amount;
            }, 0);

            model.hasFees = model.totalFeeAmount > 0;

            model.totalAmount = model.totalCardAmount + model.totalFeeAmount;
            updatePaymentsTotal();

            if (model.hasCards) {
                model.paymentTypes = rejectIntegratedPaymentTypes(preActivationService.getPaymentTypes());
            } else {
                activationService.getPaymentTypes().then(function (data) {
                    model.paymentTypes = rejectIntegratedPaymentTypes(data);
                });
            }

            model.allowMarketingOptIn = preActivationService.getAllowMarketingOptIn();
            model.merchantGroupCountry = preActivationService.getMerchantGroupCountry();
            model.supportsCustomerAtCardLevel = appConfig.selectedMerchantGroup().supportsCustomerAtCardLevel;
        }

        function getCurrencySymbol() {
            if (preActivationService.hasCards()) {
                return preActivationService.getCardsPreActivated()[0].bin.currency.currencySymbol;
            }

            return null;
        }

        function rejectIntegratedPaymentTypes(allPaymentTypes) {
            var filteredPayments = _.reject(allPaymentTypes, function (paymentType) {
                return paymentType.isAuthorizable === true;
            });

            return _.filter(filteredPayments, function (paymentType) {
                return paymentType.allowedByAmlForCorporate === true;
            });
        }

        function refreshFeeTab() {
            if (activeTab === TAB_NAMES.FEES) {
                $scope.$broadcast($scope.HVT_FEES_TAB_SHOWN_EVENT, {});
            }
        }

        function cancelSale() {
            var cancelConfirmModalInstance = $uibModal.open({
                templateUrl: "hvt-sale-summary/modal/cancelConfirmDialog.html",
                backdrop: "static",
                keyboard: false,
                size: "sm",
                controller: "ConfirmModal",
                scope: $scope
            })

            cancelConfirmModalInstance.result.then(function (confirmed) {
                if (confirmed) {
                    $rootScope.$broadcast('hvtFulfillmentCancelled');
                }
            });
        }

        function completeSale() {
            model.completeSaleInProgress = true;

            activateCards();

            $rootScope.selectedPaymentType = undefined;
            model.completeSaleInProgress = false;
        }

        function completeSaleButtonEnabled() {
            var enabled = true;

            if (!model.meetsSaleRequirements() || model.completeSaleInProgress) {
                enabled = false;
            }

            if (model.customer?.requireCIP && (model.customer.firstName && model.customer.lastName && model.customer.address1 && model.customer.city && model.customer.birthDate && model.customer.kycDocumentType && model.customer.kycDocumentId && model.customer.kycExpiryDate )) {
                enabled = true;
            }

            return enabled;
        }
    }
}());